import { useState } from 'react';
import { collection, addDoc, getDoc, doc } from 'firebase/firestore';
import { db } from '../services/firebase';
import { useAuth } from '../contexts/authcontext';

function FeedbackForm() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const { user } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitted(false);
    try {
      if (!user) {
        setError('You must be logged in to submit feedback.');
        return;
      }
      await addDoc(collection(db, 'feedback'), {
        name,
        email,
        message,
        userId: user.uid,
        timestamp: new Date()
      });
      setSubmitted(true);
      setName('');
      setEmail('');
      setMessage('');
    } catch (err) {
      setError('Failed to submit feedback: ' + err.message);
    }
  };

  return (
    <div
      style={{
        minHeight: 'calc(100vh - 60px)',
        background: 'linear-gradient(135deg, #1e1e2f 0%, #2d3748 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        fontFamily: 'Poppins, sans-serif'
      }}
    >
      <div
        style={{
          backgroundColor: 'rgba(45, 55, 72, 0.9)',
          padding: '2rem',
          borderRadius: '12px',
          boxShadow: '0 6px 12px rgba(0, 0, 0, 0.3)',
          width: '100%',
          maxWidth: '500px',
          backdropFilter: 'blur(5px)'
        }}
      >
        <h2
          style={{
            color: '#e0e0e0',
            fontFamily: 'Poppins, sans-serif',
            textAlign: 'center',
            marginBottom: '1.5rem'
          }}
        >
          Submit Feedback
        </h2>
        {submitted && (
          <p
            style={{
              color: '#4A90E2',
              textAlign: 'center',
              marginBottom: '1rem'
            }}
          >
            Thank you for your feedback!
          </p>
        )}
        {error && (
          <p
            style={{
              color: '#ff5555',
              textAlign: 'center',
              marginBottom: '1rem'
            }}
          >
            {error}
          </p>
        )}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1rem' }}>
            <label
              style={{
                display: 'block',
                color: '#e0e0e0',
                fontFamily: 'Poppins, sans-serif',
                marginBottom: '0.5rem'
              }}
            >
              Name
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Your name"
              required
              style={{
                width: '100%',
                padding: '8px',
                backgroundColor: '#4a5568',
                color: '#e0e0e0',
                border: '1px solid #4a5568',
                borderRadius: '4px',
                fontFamily: 'Poppins, sans-serif'
              }}
            />
          </div>
          <div style={{ marginBottom: '1rem' }}>
            <label
              style={{
                display: 'block',
                color: '#e0e0e0',
                fontFamily: 'Poppins, sans-serif',
                marginBottom: '0.5rem'
              }}
            >
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email"
              required
              style={{
                width: '100%',
                padding: '8px',
                backgroundColor: '#4a5568',
                color: '#e0e0e0',
                border: '1px solid #4a5568',
                borderRadius: '4px',
                fontFamily: 'Poppins, sans-serif'
              }}
            />
          </div>
          <div style={{ marginBottom: '1rem' }}>
            <label
              style={{
                display: 'block',
                color: '#e0e0e0',
                fontFamily: 'Poppins, sans-serif',
                marginBottom: '0.5rem'
              }}
            >
              Feedback
            </label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Your feedback"
              required
              style={{
                width: '100%',
                padding: '8px',
                backgroundColor: '#4a5568',
                color: '#e0e0e0',
                border: '1px solid #4a5568',
                borderRadius: '4px',
                fontFamily: 'Poppins, sans-serif',
                minHeight: '100px'
              }}
            />
          </div>
          <button
            type="submit"
            style={{
              width: '100%',
              padding: '10px',
              background: 'linear-gradient(90deg, #4A90E2 0%, #357ABD 100%)',
              color: '#e0e0e0',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 600,
              transition: 'transform 0.1s ease, background 0.3s ease'
            }}
            onMouseOver={(e) =>
              (e.target.style.background = 'linear-gradient(90deg, #5BA3F5 0%, #468CD0 100%)')
            }
            onMouseOut={(e) =>
              (e.target.style.background = 'linear-gradient(90deg, #4A90E2 0%, #357ABD 100%)')
            }
          >
            Submit Feedback
          </button>
        </form>
        
        {/* Support Contact Info */}
        <div style={{
          marginTop: '2rem',
          padding: '1rem',
          backgroundColor: '#2a2a42',
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <p style={{
            color: '#a0aec0',
            fontFamily: 'Poppins, sans-serif',
            fontSize: '14px',
            margin: '0 0 0.5rem 0'
          }}>
            Need direct support?
          </p>
          <p style={{
            color: '#4A90E2',
            fontFamily: 'Poppins, sans-serif',
            fontSize: '16px',
            fontWeight: '600',
            margin: '0'
          }}>
            <a 
              href="mailto:ZBTSupport@zentekconsultants.net"
              style={{
                color: '#4A90E2',
                textDecoration: 'none'
              }}
              onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
              onMouseOut={(e) => e.target.style.textDecoration = 'none'}
            >
              ZBTSupport@zentekconsultants.net
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default FeedbackForm; 